import React from "react";
import { useTranslation } from "react-i18next";

import WindowWrapper from "../components/WindowWrapper";

function SearchScreen(props) {
  const { t } = useTranslation();
  return (
    <WindowWrapper
      t={t}
      uiSettingsProp={"searchScreen"}
      generateFlexLayoutJson={() => ({
        global: {
          tabEnableRename: true,
          tabSetEnableClose: true,
        },
        borders: [
          {
            type: "border",
            location: "top",
            barSize: 64,
            children: [],
          },
        ],
        layout: {
          type: "row",
          children: [
            {
              type: "row",
              children: [
                {
                  type: "tabset",
                  weight: 70,
                  children: [
                    {
                      type: "tab",
                      name: t("tree"),
                      component: "search",
                      config: {
                        treeRoot: props.treeRoot,
                      },
                    },
                  ],
                },
              ],
            },
            {
              type: "tabset",
              children: [
                {
                  id: "nodeForm",
                  type: "tab",
                  name: "",
                  component: "node",
                  enableClose: false,
                  config: {
                    disableEditing: true,
                  },
                },
              ],
            },
          ],
        },
      })}
    />
  );
}

export default SearchScreen;
